<template>
  <div class="projects-page">
    <v-row><h1 class="projects-title mb-4">Projects</h1></v-row>
    <div class="projects-wrapper mb-4 mt-4">  
      <transition :name="transitionName" mode="out-in">
        <v-row :key="currentIndex">
          <v-col class="projects-image content-zone">
            <img :src="currentProject.image" alt="" class="project-image" />
          </v-col>
          <v-col class="projects-summary content-zone">
            <h1 class="pb-4">
              {{ currentProject.title }}
            </h1>
            <p>
              {{ currentProject.summary }}
            </p>
          </v-col>
        </v-row>
      </transition>
    </div>
    <v-row class="projects-controls ">
      <v-col class="projects-button">
        <button class="nav-button" @click="prevProject"><v-icon>mdi-arrow-left-thin</v-icon></button>
      </v-col>
      <v-col class="projects-button">
        <!-- <button class="nav-button" @click="goToProject">Go to Project</button> -->
        <button class="nav-button" @click="goToProject"><v-icon>mdi-open-in-app</v-icon></button>
      </v-col>
      <v-col class="projects-button">
        <button class="nav-button" @click="nextProject"><v-icon>mdi-arrow-right-thin</v-icon></button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import acImage from "@/assets/AC project.png";
export default {
  name: "ProjectsPage",
  data() {
    return {
      currentIndex: 0,
      transitionName: "slide-right",
      projects: [
        {
          title: "Animal Crossing Ambience",
          image: acImage,
          summary: "Dynamically loads video player using the YouTube IFrame API. Checks the system time to update the video based on the hour.",
          link: "/ac"
        },
        {
          title: "Animal Crossing Ambience",
          image: acImage,
          summary: "Dynamically loads video player using the YouTube IFrame API. Checks the system time to update the video based on the hour.",
          link: "/ac"
        },
      ]
    };
  },
  computed: {
    currentProject() {
      return this.projects[this.currentIndex];
    },
  },
  methods: {
    nextProject() {
      this.transitionName = "slide-right";
      if (this.currentIndex < this.projects.length - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0; // loop to start if you'd like
      }
    },
    prevProject() {
      this.transitionName = "slide-left";
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.projects.length - 1; // loop to end
      }
    },
    goToProject() {
      this.$router.push(this.currentProject.link);
    },
  }
  
};
</script>

<style scoped>
.projects-page {
  text-align: center;
  padding: 20px;
}
.projects-summary, .projects-image, .projects-title {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 15px;
  border-radius: 10px;
  border: 3px solid #ddaf52;
}
.projects-summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: clamp(14px, 1.6vw, 20px);
  margin-left: 1.25vw;
  margin-right: 2.5vw;
}
.projects-image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: clamp(14px, 1.6vw, 20px);
  margin-left: 2.5vw;
  margin-right: 1.25vw;
}
.project-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 10px; /* Optional: match the container's rounded corners */
}
.projects-title {
  font-size: clamp(5vh, 5.5vw, 6vh);
  margin-left: 2.5vw;
  text-align: left;
}
.content-zone {
  height: 57vh;
  display: flex;
  flex-direction: column;
}
.projects-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: clamp(20px, 3vw, 36px);
  margin-left: 2.5vw;
  margin-right: 2.5vw;
}
.projects-wrapper {
  position: relative;
  display: grid;
  min-height: 57vh; /* matches .content-zone height */
  min-width: 100vw; /* Ensures it always spans the full container width */
  align-items: center; /* vertical centering */
}

.nav-button {
  color: #01295a;
  padding: 12px 18px;
  text-align: center;
  font-size: 18px;
  text-decoration: none;
  margin: 6px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  font-family: "Poppins", sans-serif;
  border: 3px solid #ddaf52;
  border-radius: 8px;
  user-select: none;
  cursor: pointer;
}
.nav-button:hover {
  color: #ffffff;
  background-color: #01295a;
  transform: scale(1.05);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.3);
}
/* === Right Slide === */
.slide-right-enter-from {
  transform: translateX(100%);
  opacity: 0;
}
.slide-right-enter-to {
  transform: translateX(0);
  opacity: 1;
}
.slide-right-leave-from {
  transform: translateX(0);
  opacity: 1;
}
.slide-right-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.5s ease;
  position: absolute;
  width: 100%;
}

/* === Left Slide === */
.slide-left-enter-from {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-left-enter-to {
  transform: translateX(0);
  opacity: 1;
}
.slide-left-leave-from {
  transform: translateX(0);
  opacity: 1;
}
.slide-left-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.5s ease;
  position: absolute;
  width: 100%;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
</style>